import * as angular from "angular";
import {IController} from "angular";
import {TaskModel} from "../../models/task.model";

export class taskInfoCardCtrl implements IController {

  task: TaskModel;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskInfoCard', {
    bindings: {
      task: '<'
    },
    template: require('./task-info-card.html').default,
    controller: taskInfoCardCtrl
  });
